import React from "react";
import dashboard_product_icon from "../../../../assets/images/users/Vector2.png";


const DashboardProductIcon = () => (
  <img
    src={dashboard_product_icon}
    alt="Products"
    style={{ width: 15, height: 15 }}
  />
);


const dashboard = {
  id: "group-dashboard",
  title: "",
  type: "group",
  children: [
    {
      id: "Products",
      title: "Products",
      type: "item",
      url: "/dashboard",
      icon: DashboardProductIcon, 
      breadcrumbs: false,
    },
  ],
};

export default dashboard;
